import { NgModule,  } from '@angular/core';
import { StateSwitcherStateComponent } from './state-switcher-state.component';

@NgModule({
  declarations: [ StateSwitcherStateComponent ],
  exports: [ StateSwitcherStateComponent ]
})
export class ZefStateSwitcherStateModule { }
